import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./components/styles/index.css";
import "./i18n/i18n";
import App from "./components/App";
import { Providers } from '@microsoft/mgt-element';
import { Msal2Provider } from '@microsoft/mgt-msal2-provider';

Providers.globalProvider = new Msal2Provider({
    clientId: "8f261936-59e1-44b3-8234-a746c5e4eab7",
    // Only request user-consentable (non-admin) scopes at login.
    // The list-users scope (User.ReadBasic.All) is requested incrementally, on
    // demand, when an admin manages license assignments. No admin-consent scopes
    // (e.g. Presence.Read.All) are requested anywhere in the app.
    scopes: ["User.Read", "People.Read"]
});

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root")
);
